import {ActionHandlerBase} from "../action-handler-base";
import {
    AppIdentifiers,
    IOpenOnlineHelpActionPayload,
    ProductPackageToID,
} from "@sparkware/uc-sdk-core";
import {
    getCasinofiedCommonAppContextParams,
    getCasinofiedDeviceInfo,
    getCasinofiedGeoInfoParams
} from "../../casinofied-helper-functions";


export class OpenOnlineHelpActionHandler extends ActionHandlerBase<IOpenOnlineHelpActionPayload> {
    async handle(payload: IOpenOnlineHelpActionPayload): Promise<void> {

        try {
            this._sendAnalytics(payload);
        } catch (e) {
            this.services.logger.error("Failed to send open online action handler analytics");
        }

        const relatedAccountCid = payload.actionData.relatedAccountCid?.toString();
        const registrationCategory = payload.actionData.registrationCategory?.toString();
        const correlationId =  payload.actionData.correlationId;
        const url = `${payload.actionData.url?.trim()}?relatedAccountCid=${relatedAccountCid}&registrationCategory=${registrationCategory}&correlationId=${correlationId}`;

        return this.services.linksNavigation.openUrl({
            url: url,
            openMode: 'newTab'
        });
    }

    private async _sendAnalytics(payload: IOpenOnlineHelpActionPayload): Promise<void> {
        const appId = this._getAppIdentifier()
        const productPackageToID = this._getProductPackageId();

        this.services.casinofiedAnalytics.openAppRequest({
            correlationID: payload.correlationID,
            launchInfo: payload.launchInfo,
            appID: appId,
        });

        const geoInfo = await getCasinofiedGeoInfoParams(this.services);
        this.services.casinofiedAnalytics.appInitRequest({
            correlationID: payload.correlationID,
            applicationContext: {
                launchInfo: payload.launchInfo,
                appID: appId,
                productPackageToID: productPackageToID,
                ...getCasinofiedCommonAppContextParams(this.services)
            },
            deviceInfo: getCasinofiedDeviceInfo(this.services),
            geoInfo: geoInfo,
            userInfo: {
                userMode: this.services.user.isAuthorized ? 'authenticated' : 'anonymous',
                regulationTypeID: this.services.regulation.getRegulationCode(),
                token: ''
            },
            messageBrokerChannels: this.services.messageBroker.channels
        });
    }


    protected _getAppIdentifier(): AppIdentifiers {
        return AppIdentifiers.OpenOnlineHelp;
    }

    protected _getProductPackageId(): ProductPackageToID {
        return ProductPackageToID.OPEN_ONLINE_HELP
    }
}